import display from '../utilities/display';

export default {...display.dInlineFlex};
